<template>
  <div>
    <h4>{{ 'plans' | t }}</h4>
    <table class="table">
      <thead>
        <tr>
          <th>Plan</th>
          <th v-for="plan in plans">{{ plan.plan.name }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Base</td>
          <td v-for="plan in plans">{{ plan.breakdown.base.price | currency }} {{ currency }}</td>
        </tr>
        <tr>
          <td>Printers</td>
          <td v-for="plan in plans" v-tooltip="tooltip(plan.breakdown.printers)">
            {{ plan.breakdown.printers.total | currency }} {{ currency }}
          </td>
        </tr>
        <tr>
          <td>Users</td>
          <td v-for="plan in plans" v-tooltip="tooltip(plan.breakdown.users)">
            {{ plan.breakdown.users.total | currency }} {{ currency }}
          </td>
        </tr>
        <tr>
          <td>Order-channels</td>
          <td v-for="plan in plans" v-tooltip="tooltip(plan.breakdown.order_channels)">
            {{ plan.breakdown.order_channels.total | currency }} {{ currency }}
          </td>
        </tr>
        <tr>
          <td>Carriers</td>
          <td v-for="plan in plans" v-tooltip="tooltip(plan.breakdown.carriers)">
            {{ plan.breakdown.carriers.total | currency }} {{ currency }}
          </td>
        </tr>
        <tr>
          <td>Shipments</td>
          <td v-for="plan in plans" v-tooltip="tooltip(plan.breakdown.shipments)">
            {{ plan.breakdown.shipments.total | currency }} {{ currency }}
          </td>
        </tr>
        <tr>
          <td>Return portals</td>
          <td v-for="plan in plans" v-tooltip="tooltip(plan.breakdown.return_portals)">
            {{ plan.breakdown.return_portals.total | currency }} {{ currency }}
          </td>
        </tr>
        <tr>
          <td>Automations</td>
          <td v-for="plan in plans" v-tooltip="tooltip(plan.breakdown.automations)">
            {{ plan.breakdown.automations.total | currency }} {{ currency }}
          </td>
        </tr>
        <tr class="font-bold text-bolder">
          <td>Total</td>
          <td v-for="plan in plans">{{ plan.cost | currency }} {{ currency }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import Api from '@/store/jsonapi';

export default {
  props: ['customer'],
  data: function () {
    return {
      plans: [],
      currency: ''
    };
  },
  mounted() {
    Api.find('customers', this.customer.id, {
      fields: { customers: 'plans' }
    }).then(({ data }) => {
      this.plans = data.plans;
      this.currency = data.plans[0].plan.currency;
    });
  },
  methods: {
    tooltip(model) {
      return `${model.price} ${this.currency} * ${model.quantity} ${this.$i18n.t('pcs')}`;
    }
  }
};
</script>
